import logo from './logo.svg';
import './App.css';
import './responsive-utils.css';
import Approutes from './Approutes';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
      <Approutes/>
      </BrowserRouter>
    </div>
  );
}

export default App;
